import {
	QuestionnaireStep,
	QuestionnaireStepSchema,
} from "@/pages/Public/pages/Questionnaire/schema/questionnaire";

import { useUpdateQuestionnaireStepMutation } from "@/pages/Public/redux/questionnaire/questionnaire.api";

import EditModeQuestionnaireItem from "./EditModeQuestionnaireItem";
import ViewModeQuestionnaireItem from "./ViewModeQuestionnaireItem";

interface EditableQuestionnaireItemProps {
	data: QuestionnaireStep;
	isEditing: boolean;
	isEditingInProcess: boolean;
	setEditing: (value: number) => void;
	setDeletingQuestionnaire: (value: QuestionnaireStep | null) => void;
	dropQuestion: (dragElementId: number, dragIndex: number, dropIndex: number) => void;
}

export default function EditableQuestionnaireItem({
	data,
	isEditing,
	setEditing,
	setDeletingQuestionnaire,
	dropQuestion,
	isEditingInProcess,
}: EditableQuestionnaireItemProps) {
	const [updateQuestionnaireStep, { isLoading }] = useUpdateQuestionnaireStepMutation();

	const handleUpdateToDo = async (values: QuestionnaireStep) => {
		try {
			await updateQuestionnaireStep(values);
		} catch (error) {
			console.error(error);
		}
	};

	return isEditing ? (
		<EditModeQuestionnaireItem
			data={data}
			isLoading={isLoading}
			setEditing={setEditing}
			validationSchema={QuestionnaireStepSchema}
			onSubmit={handleUpdateToDo}
		/>
	) : (
		<ViewModeQuestionnaireItem
			data={data}
			dropQuestion={dropQuestion}
			isEditingInProcess={isEditingInProcess}
			isLoading={false}
			setDeletingQuestionnaire={setDeletingQuestionnaire}
			setIsEditing={setEditing}
			stepNumber={data?.stepNumber ?? 0}
		/>
	);
}
